"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3073],{

/***/ 42980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58598);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var Actions = function Actions(_ref) {
  var active = _ref.active,
      primary = _ref.primary,
      hasSecondaryAction = _ref.hasSecondaryAction,
      secondary = _ref.secondary,
      inline = _ref.inline;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .SimpleGrid */ .MI, {
    columns: {
      base: inline && hasSecondaryAction ? 2 : 1,
      md: inline ? 2 : 1
    },
    spacing: {
      base: '1rem',
      md: inline ? '1.5rem' : '.5rem'
    },
    children: [hasSecondaryAction && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .SecondaryButton */ .kq, {
      title: secondary.title,
      action: secondary.action,
      onClick: secondary.onClick
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .PrimaryButton */ .KM, {
      title: primary.title,
      action: primary.action,
      onClick: primary.onClick,
      disabled: !active
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Actions);

/***/ }),

/***/ 43073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48641);
/* harmony import */ var src_uikit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58598);
/* harmony import */ var src_components_OfferDetails_Actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42980);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var StickyBar = function StickyBar(_ref) {
  var visible = _ref.visible,
      sectionTitle = _ref.sectionTitle,
      subtitle = _ref.subtitle,
      priceValue = _ref.priceValue,
      priceDescription = _ref.priceDescription,
      durationTitle = _ref.durationTitle,
      durationValue = _ref.durationValue,
      distanceValue = _ref.distanceValue,
      distanceTitle = _ref.distanceTitle,
      depositValue = _ref.depositValue,
      depositTitle = _ref.depositTitle,
      expirationValue = _ref.expirationValue,
      active = _ref.active,
      primary = _ref.primary,
      hasSecondaryAction = _ref.hasSecondaryAction,
      secondary = _ref.secondary;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .Sticky */ .Le, {
    visible: visible,
    padding: "1rem",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Grid */ .rj, {
      templateColumns: {
        base: '1fr 2.4fr',
        md: 'repeat(12, 1fr)'
      },
      templateRows: {
        base: 'repeat(2, 1fr)',
        md: '1fr'
      },
      gap: "3",
      width: "100%",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .GridItem */ .P4, {
        marginY: "auto",
        textAlign: "left",
        colSpan: 3,
        display: {
          base: 'none',
          md: 'block'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
          color: "baseDark",
          fontFamily: "Montserrat-SemiBold",
          fontSize: "1.375rem",
          lineHeight: "28.6px",
          letterSpacing: "0.6px",
          mb: "xxs",
          children: sectionTitle
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
          color: "baseNeutral.700",
          fontFamily: "Montserrat-Regular",
          fontSize: "0.875rem",
          lineHeight: "18px",
          letterSpacing: "0.2px",
          marginTop: "0rem!important",
          children: subtitle
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .GridItem */ .P4, {
        marginY: "auto",
        mt: "2px",
        textAlign: "left",
        colSpan: {
          base: 5,
          md: 4
        },
        display: {
          base: 'none',
          md: 'block'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
          mb: "xs",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
            color: "baseDark",
            fontFamily: "Montserrat-SemiBold",
            fontSize: "1rem",
            lineHeight: "20.8px",
            letterSpacing: "0.2px",
            display: "inline",
            children: t('offerContainer:sectionTitle')
          }), expirationValue && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .LimitedOfferBadge */ .Ld, {
            display: "inline",
            float: "right",
            children: ["solo ", expirationValue, " GIORNI"]
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Medium",
          fontSize: ".75rem",
          letterSpacing: "0.3px",
          children: "".concat(durationTitle, " ").concat(durationValue, " | ").concat(distanceTitle, " ").concat(distanceValue, " | ").concat(depositTitle, " ").concat(depositValue)
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .GridItem */ .P4, {
        textAlign: "left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_uikit__WEBPACK_IMPORTED_MODULE_1__/* .PriceBox */ .bz, {
          value: priceValue,
          description: priceDescription
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .GridItem */ .P4, {
        marginY: "auto",
        marginX: {
          base: '',
          md: 'xxl'
        },
        mr: "-3",
        textAlign: {
          base: 'right',
          md: 'left'
        },
        w: {
          base: '',
          md: '30rem'
        },
        display: {
          base: 'block',
          md: 'none'
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Medium",
          fontSize: ".75rem",
          letterSpacing: "0.3px",
          children: "".concat(durationTitle, " ").concat(durationValue, " | ").concat(distanceTitle, " ").concat(distanceValue)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
          color: "baseDark",
          fontFamily: "Montserrat-Medium",
          fontSize: ".75rem",
          letterSpacing: "0.3px",
          children: "".concat(depositTitle, " ").concat(depositValue)
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .GridItem */ .P4, {
        colSpan: {
          base: 3,
          md: 4
        },
        textAlign: {
          base: 'center',
          md: 'right'
        },
        marginLeft: {
          base: '0',
          md: '0.34rem'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(src_components_OfferDetails_Actions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          active: active,
          primary: primary,
          hasSecondaryAction: hasSecondaryAction,
          secondary: secondary,
          inline: true
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (StickyBar);

/***/ })

}]);